import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, } from '@angular/forms';
import {TranslateModule} from 'ng2-translate';
import { TooltipModule } from 'ng2-tooltip';
import { MyDatePickerModule } from 'mydatepicker';

import { InlineEditorModule } from '../../../../shared/modules/inline-editor/inline-editor.module';
import { ConfirmationModule } from '../../../../shared/modules/confirmation/confirmation.module';
import {NgxPaginationModule} from 'ngx-pagination';
import { TimeSheetsComponent } from './time-sheets.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    TranslateModule,
    TooltipModule,
    MyDatePickerModule,

    InlineEditorModule,
    ConfirmationModule,
    NgxPaginationModule
  ],
  declarations: [TimeSheetsComponent],
  exports: [TimeSheetsComponent]
})
export class TimeSheetModule { }



// WEBPACK FOOTER //
// ./src/app/modules/work/modal/time-sheet/time-sheet.module.ts